module.exports = __webpack_public_path__ + "assets/images/default-teacherResource.8038009f30e37f7dda582547a317335f.svg";